import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import {
  constants,
} from 'cng-web-lib'
import UaeMpciKeys from 'src/constants/locale/key/UaeMpci'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )
  let dateTypeErrorMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.DATE_TYPE_ERROR
  )

  const errMsgAlphaNumericWithSpecialChar = translate(
    Namespace.UAE_MPCI,
    UaeMpciKeys.ValidationMessage.ERROR_MSG_ALPHA_NUMERIC_WITH_SPECIAL_CHAR
  )

  const errMsgAlphaNumericWithSpecialCharNoSpace = translate(
    Namespace.UAE_MPCI,
    UaeMpciKeys.ValidationMessage.ERROR_MSG_ALPHA_NUMERIC_WITH_SPECIAL_CHAR_NO_SPACE
  )

  const errMsgNumeric = translate(
    Namespace.UAE_MPCI,
    UaeMpciKeys.ValidationMessage.ERROR_MSG_NUMERIC
  )

  const errMsgMaxLength = translate(
    Namespace.UAE_MPCI,
    UaeMpciKeys.ValidationMessage.ERROR_MSG_MAX_LENGTH
  )

  const regexNumeric = '^[0-9]*$'
  const regexAlphaNumericWithSpecialChar =
    '^[a-zA-Z0-9 ,+\\-$#@%&()!\'`^_:;.?\\[\\]\\{\\}\\/="\\|\\\\ ]+$'
  const regexAlphaNumericWithSpecialCharNoSpace =
    '^[a-zA-Z0-9,+\\-$#@%&()!\'`^_:;.?\\[\\]\\{\\}\\/="\\|\\\\]+$'

  return Yup.object({
    filingOperator: Yup.string().nullable().required(requiredMessage),
    uaeFFMpciPartyId: Yup.string().nullable().required(requiredMessage).matches('^[a-zA-Z0-9]*$', errMsgAlphaNumericWithSpecialCharNoSpace).max(7, errMsgMaxLength + " 7"),
    documentType: Yup.string().nullable().required(requiredMessage),
    billNo: Yup.string().nullable().required(requiredMessage).matches(regexAlphaNumericWithSpecialCharNoSpace, errMsgAlphaNumericWithSpecialCharNoSpace).max(70, errMsgMaxLength + " 70"),
    parentBillNo: Yup.string().nullable().required(requiredMessage).matches(regexAlphaNumericWithSpecialCharNoSpace, errMsgAlphaNumericWithSpecialCharNoSpace).max(70, errMsgMaxLength + " 70"),
    originalBillNo: Yup.string().nullable().matches(regexAlphaNumericWithSpecialCharNoSpace, errMsgAlphaNumericWithSpecialCharNoSpace).max(70, errMsgMaxLength + " 70"),
    functionType: Yup.string().nullable().required(requiredMessage),
    reasonForUpdatingFiling: Yup.string().nullable().matches(regexAlphaNumericWithSpecialChar, errMsgAlphaNumericWithSpecialChar).max(512, errMsgMaxLength + " 512"),
    processingIndicator: Yup.string().nullable().required(requiredMessage),
    bolIssueDate: Yup.lazy((value) => value === '' || value === null ? Yup.string().nullable() : Yup.date().nullable().validFormat().typeError(dateTypeErrorMessage)),
    sobDate: Yup.lazy((value) => value === '' || value === null ? Yup.string().nullable() : Yup.date().nullable().validFormat().typeError(dateTypeErrorMessage)),
    placeOfBillIssueCountry: Yup.string().nullable().max(2, errMsgMaxLength + " 2"),
    billIssueLocationName: Yup.string().nullable().matches(regexAlphaNumericWithSpecialChar, errMsgAlphaNumericWithSpecialChar).max(256, errMsgMaxLength + " 256"),
    freightPayableCountry: Yup.string().nullable().max(2, errMsgMaxLength + " 2"),
    freightLocationName: Yup.string().nullable().matches(regexAlphaNumericWithSpecialChar, errMsgAlphaNumericWithSpecialChar).max(256, errMsgMaxLength + " 256"),
    shipmentType: Yup.string().nullable().required(requiredMessage),
    shipmentDescription: Yup.string().nullable().matches(regexAlphaNumericWithSpecialChar, errMsgAlphaNumericWithSpecialChar).max(35, errMsgMaxLength + " 35"),
    totalFFBills: Yup.string().nullable().required(requiredMessage).matches(regexNumeric, errMsgNumeric).max(18, errMsgMaxLength + " 18"),
    filingOperatorMpciPartyId: Yup.string().nullable(),
    status: Yup.string().nullable(),
    vesselInfo: Yup.array().nullable(),
    containerDetails: Yup.array().nullable(),
    consignmentDetails: Yup.array().nullable(),
    partiesInfo: Yup.array().nullable(),
    goodsInfo: Yup.array().nullable(),
    splitGoods: Yup.array().nullable(),
  })
}

export default makeValidationSchema
